import { Button, ButtonType } from "@constellation-academy/epic-ui";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ValidatedField } from "@components/ValidatedField";
import { inputFieldClass } from "@features/users/select-single-user-form/select-single-user-form.styles";
import { SelectUserField } from "@features/users/select-user-field";
import { useTranslation } from "@i18n/hooks";
import {
	SelectMultipleUsersFormProps,
	SelectMultipleUsersFormState,
} from "./select-multiple-users-form.types";

export const SelectMultipleUsersForm = ({
	onUsersSelected,
	disabled,
	accountId,
}: SelectMultipleUsersFormProps) => {
	const { t } = useTranslation("common");
	const formik = useFormik<SelectMultipleUsersFormState>({
		initialValues: {},
		isInitialValid: false,
		validateOnChange: false,
		validateOnBlur: false,
		validationSchema: Yup.object().shape({
			userIds: Yup.array()
				.of(Yup.string())
				.min(1, t("user.minOneRequired"))
				.required(t("user.selectAtLeastOne")),
		}),
		onSubmit: (data, { setSubmitting }) => {
			onUsersSelected(data.userIds!);
			setSubmitting(false);
		},
	});

	return (
		<form onSubmit={formik.handleSubmit} className="w-12 p-fluid mb-5">
			<ValidatedField<SelectMultipleUsersFormState, string[]>
				className={inputFieldClass}
				name={"userIds"}
				label={t("user.selectUsers")}
				formikConfig={formik}
				component={(renderConfig) => (
					<SelectUserField accountId={accountId} {...renderConfig} isMultipleSelection />
				)}
			/>
			<Button
				disabled={!formik.isValid || disabled}
				label={t("user.addUsers")}
				type={ButtonType.Submit}
			/>
		</form>
	);
};
